module.exports = __webpack_public_path__ + "img/Porto Apartment - 23 of 85.fc856d64.jpeg";